import { httpRequest } from '../../shared/lib/utils/httpClient';
export type Facility = {
  id: number;
  name: string;
};

export type Partner = {
  partnerId: number;
  partnerName: string;
  facilities: Facility[];
};

export type PartnerFacilitiesFilter = {
  partnerFacilitiesMap: Partner[];
  statusList: Facility[];
  facilityUserRoleList: Facility[];
  consultStatusList: Facility[];
  opsStaffRoleList: Facility[];
  followUpList: Facility[];
};
export type SelectedState = {
  [partnerId: number]: number[];
};

export const getPartnerFacilityFilterData = async () //   userId: string
: Promise<PartnerFacilitiesFilter> => {
  const response = await httpRequest<PartnerFacilitiesFilter>({
    method: 'GET',
    url: `/operation/filter/partner-facilities`,
    // headers: { userId },
  });
  return response;
};
